import React, { useState, useEffect, Fragment } from "react";
import cuid from "cuid";
import { TimelineDropdown } from "../../../../../partials/display/timeLine/TimelineDropdown";
import TimelineItem from "../../../../../partials/display/timeLine/TimelineItem";
import { getTimelineByContactId } from "../../../crud/contactsCrud";
import ThemeButton from "../../../../../partials/button/ThemeButton";
import { getMenu } from "../../../../../GeneralApi/GeneralApi";
import { formToQueryString } from "../../../../../_helpers/_utils/utils";
import { Waypoint } from "react-waypoint";
import AccessControl from "../../../../../_ accessControl/AccessControl";

export default function ContactsTimeline({ contactId }) {
  const [selected, setSelected] = useState([]);

  const [pastTimelineOtherData, setPastTimelineOtherData] = useState(null);
  const [pastTimeline, setPastTimeline] = useState([]);
  const [futureTimeline, setFutureTimeline] = useState([]);

  const [timelineType, setTimelineType] = useState(null);




  useEffect(() => {
    let query = "timeline_activity_type";

    getMenu(query)
      .then(({ data: { data } }) => {
        setTimelineType(
          data.timeline_activity_type.map((s) => ({
            label: s.name,
            value: s.id,
          }))
        );
      })
      .catch(() => {});

    // setTimeout(() => {
    //   let elmnt = document.getElementById("timeline-button");
    //   elmnt.scrollIntoView({behavior: "smooth"});
    // }, 2000);
  }, []);

  useEffect(() => {
    let selectedOptions = selected.map(function(el) {
      return el.value;
    });

    setPastTimeline([]);
    setFutureTimeline([]);
    setPastTimelineOtherData([]);
    getPastUpdate(
      formToQueryString({
        type: selectedOptions,
        contact: contactId,
        direction: "past",
        limit: 20,
      })
    );
    let futureQuery = formToQueryString({
      contact: contactId,
      type: selectedOptions,
      limit: 50,
    });
    console.log(futureQuery);
    getFutureUpdate(futureQuery);
    setTimeout(() => {
      if (document.getElementById("timeline-button")) {
        let elmnt = document.getElementById("timeline-button");
        elmnt.scrollIntoView({ behavior: "smooth" });
      }
    }, 2000);
  }, [selected, contactId]);

  const getPastUpdate = (prams) => {
    getTimelineByContactId(prams)
      .then((res) => {
        console.log(res);
        let { data, ...other } = res.data;
        console.log(data);
        console.log(res.data);

        setPastTimeline(data);
        setPastTimelineOtherData(other);
      })
      .catch(() => {});
  };

  const getFutureUpdate = (prams) => {
    getTimelineByContactId(prams)
      .then(({ data: { data } }) => {
        setFutureTimeline(data);
      })
      .catch(() => {});
  };

  const handlePastGetmore = () => {
    let selectedOptions = selected.map(function(el) {
      return el.value;
    });

    // alert(pastTimelineOtherData.current_page+" "+pastTimelineOtherData?.last_page );
    if (
      pastTimelineOtherData?.current_page != pastTimelineOtherData?.last_page
    ) {
      let pastQuery = formToQueryString({
        type: selectedOptions,
        direction: "past",
        limit: 20,
        page: pastTimelineOtherData.current_page + 1,
      });
      getTimelineByContactId(pastQuery)
        .then((res) => {
          console.log(res);
          let { data, ...other } = res.data;
          console.log(data);
          console.log(res.data);

          setPastTimeline(data.concat(pastTimeline));
          setPastTimelineOtherData(other);
        })
        .catch(() => {});
    }
  };

  return (
    <React.Fragment>
      <div className="timeline-dropdown d-flex justify-content-end">
        <AccessControl
          allowedPermissions={["contacts-download"]}
          renderNoAccess={() => ""}
        >
          <ThemeButton icon>
            <i className="fas fa-download    "></i>
          </ThemeButton>
        </AccessControl>

        <div className="float-item">
          {timelineType ? (
            <TimelineDropdown
              options={timelineType}
              value={selected}
              onChange={setSelected}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="timeline-body">
        <div className="timeline timeline-5" id="scrolling_div">
          {futureTimeline.length
            ? futureTimeline?.map((item, i) => (
                <Fragment key={i}>
                  <TimelineItem
                    date={item.timeline_date}
                    text={item.text}
                    type={item.type}
                    id={item.id}
                  />
                  {console.log(item)}
                </Fragment>
              ))
            : ""}
          <div className="timeline-item align-items-start timeline-start-button">
            <div className="timeline-label"></div>
            <div className="timeline-badge" id="contact-timeline">
              <ThemeButton id="timeline-button" className="timeline-button">
                {" "}
                Now{" "}
              </ThemeButton>
            </div>
            <div className="timeline-content"></div>
          </div>
          {pastTimeline.length
            ? pastTimeline?.map((item, i) => (
                <Fragment key={i}>
                  <TimelineItem
                    date={item.timeline_date}
                    text={item.text}
                    type={item.type}
                    id={item.id}
                  />
                 
                </Fragment>
              ))
            : ""}
          <Waypoint onEnter={handlePastGetmore} />
        </div>
      </div>
    </React.Fragment>
  );
}
